.button-group {
    display: flex;
}

.button-group--align-start {
    align-items: flex-start;
}

.button-group--align-end {
    align-items: flex-end;
}

.button-group--align-center {
    align-items: center;
}

.button-group--flex-shrink {
    flex-shrink: 0;
}

.button-group--flex-wrap {
    flex-wrap: wrap;
    gap: 4px;
}

.button-group--flex-wrap-end {
    justify-content: flex-end;
}

.button-group--flex-wrap-start {
    justify-content: flex-start;
}
